import type { GetLectureDetail200ContentType } from './getLectureDetail200ContentType';

export type GetLectureDetail200 = {
  /** 강의 콘텐츠 유형 */
  contentType: GetLectureDetail200ContentType;
  /**
   * 강의 항목에 대한 추가 설명
   * @nullable
   */
  description?: string | null;
  /** 강의 항목 ID */
  id: number;
  /**
   * 마크다운 콘텐츠 파일 URL
   * @nullable
   */
  markdownUrl?: string | null;
  /** 강의 항목 제목 */
  title: string;
  /**
   * 비디오 콘텐츠 URL (HLS 마스터 플레이리스트 등)
   * @nullable
   */
  videoUrl?: string | null;
};
